import Header from "./topMenu";
import React from "react";
import { Grid } from "@mui/material";

interface LayoutProps {
    logout: () => void;
}

export default function Layout(props: LayoutProps) {
    return (
        <Grid container sx={{ width: "100%" }}>
            <Header logout={props.logout} />
        </Grid>
    );
}
